export const clinicTabsEnums = {
  BASIC_INFORMATION: '1',
  LOCATION_CONTACT: '2',
  PRACTICE_DETAILS: '3',
  SERVICES_OFFERED: '4',
  SERVICES_CONFIG: '5',
  BILLING_PROFILE: '6',
  BILLING_MACROS: '7'
}
